import { ENDPOINTS } from 'config/endpoints';
import { useQuery } from '@tanstack/react-query';
import CronoError from 'crono-fe-common/types/error';
import client from 'utils/clients/client';
import { Request } from 'crono-fe-common/types/request';
import { Response } from 'crono-fe-common/types/response';
import queryString from 'query-string';
import { CronoAttachment } from 'crono-fe-common/types/cronoAttachment';

export default function useGetTemplateAttachments(templateId: number | null) {
  const queryParams = queryString.stringify({ templateId });

  const request: Request = {
    url: `${ENDPOINTS.template.attachment.main}?${queryParams}`,
    config: {
      method: 'get',
    },
  };
  const requestConfig = {
    queryKey: [ENDPOINTS.template.attachment.main, templateId],
    queryFn: () => client(request),
    enabled: templateId !== null && templateId !== -1,
    refetchOnWindowFocus: false,
  };

  const { data, ...rest } = useQuery<Response<CronoAttachment[]>, CronoError>(
    requestConfig,
  );

  return { data, ...rest };
}
